import { Button, Popover } from '@mui/material'
import { EditPencilIcon } from 'assets/icons/edit-pencil-icon'
import { Mail } from 'assets/icons/mail'
import { UserX } from 'assets/icons/user-x'

type Props = {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
  user: CognitoUser | null
  onEdit: (user: CognitoUser) => void
  onResendInvitation: (user: CognitoUser) => void
  onDelete: (user: CognitoUser) => void
}

export default function AdminUserEditPopover({
  open,
  anchorEl,
  onClose,
  user,
  onEdit,
  onResendInvitation,
  onDelete,
}: Props): JSX.Element {
  if (!user) {
    return <></>
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          display: 'flex',
          width: '206px',
          padding: '5px',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: '1px',
          borderRadius: '11px',
          border: '1px solid #E4E4E7',
          background: '#FFF',
          boxShadow: '0 2px 4px -2px rgba(0, 0, 0, 0.08), 0 4px 6px -1px rgba(0, 0, 0, 0.08)',
        },
      }}
      sx={{
        display: 'flex',
        padding: '5px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& .MuiPaper-root': {
          display: 'flex',
          width: '206px',
          borderRadius: '10px',
          gap: '2px',
          padding: '5px',
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
      }}
    >
      <Button
        fullWidth
        onClick={() => {
          onEdit(user)
          onClose()
        }}
        sx={{
          justifyContent: 'flex-start',
          textTransform: 'none',
          color: '#373D40',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '16px',
          gap: '2px',
        }}
        startIcon={<EditPencilIcon />}
      >
        Edit user
      </Button>

      <Button
        fullWidth
        onClick={() => {
          onResendInvitation(user)
          onClose()
        }}
        sx={{
          justifyContent: 'flex-start',
          textTransform: 'none',
          color: '#373D40',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '16px',
        }}
        startIcon={<Mail />}
        disabled={user.UserStatus !== 'FORCE_CHANGE_PASSWORD'}
      >
        Resend Invitation
      </Button>

      <Button
        fullWidth
        color="error"
        onClick={() => {
          onDelete(user)
          onClose()
        }}
        sx={{
          justifyContent: 'flex-start',
          textTransform: 'none',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '16px',
        }}
        startIcon={<UserX />}
      >
        Delete user
      </Button>
    </Popover>
  )
}
